/* global COMPANY_ID */

'use strict'

export class CompanyService {
  constructor($q, $http) {
    'ngInject'
    Object.assign(
      this,
      { $q, $http },
      {
        companyId: COMPANY_ID,
      },
    )
  }

  getEquipments() {
    return this.$http({
      method: 'GET',
      url: '/api/companies/' + this.companyId + '/equipments',
      cache: true,
    }).then((result) => result.data)
  }

  getMaterials() {
    return this.$http({
      method: 'GET',
      url: '/api/companies/' + this.companyId + '/materials',
      cache: true,
    }).then((result) => result.data)
  }

  getContractTemplates() {
    return this.$http({
      method: 'GET',
      url: '/api/companies/' + this.companyId + '/contracttemplates',
      cache: true,
    }).then((result) => result.data)
  }

  getCategories() {
    return this.$http({
      method: 'GET',
      url: '/api/companies/' + this.companyId + '/categories',
      cache: true,
    }).then((result) => result.data)
  }

  getDates(zip) {
    return this.$http({
      method: 'GET',
      url: '/api/companies/' + this.companyId + '/dates',
      cache: true,
      params: { zip },
    }).then((result) => result.data)
  }
}



// WEBPACK FOOTER //
// ./app/shared/services/company.service.js